export const PUBLIC_VECTOR_ENGINE_NAME = 'Vectria Vector Engine' as const;
